// Словарь подпроекта 8 «Т-Банк»: подключение, выписка из банка, остаток по банку. Подключается в `ru.ts`.

const lines = (prefix: string, suffix: string) => ({
  one: `${prefix} {count} строка ${suffix}`,
  few: `${prefix} {count} строки ${suffix}`,
  many: `${prefix} {count} строк ${suffix}`,
  other: `${prefix} {count} строки ${suffix}`,
});

/** «Т-Банк» в финансах и настройках (ключи `finance.bank.*`). */
export const ruFinanceBank = {
  provider: 'Т-Банк',
  accountTitle: 'Т-Банк {number}',
  title: 'Т-Банк',
  lead: 'Выписка и остатки по счетам Т-Банка — без загрузки файлов',
  hint: {
    title: 'Что даёт подключение',
    text: 'Платформа сама забирает операции по счетам Т-Банка каждые 5 минут, а с вебхуком — за секунды: узнаёт оплаты счетов по номеру в назначении или по ИНН и сумме и открывает этапы, которые их ждали. Остальное — в «Разобрать», как с файлом. Токен хранится зашифрованным и назад не показывается',
    example: 'Клиент оплатил СЧ-2026-0012 — через несколько минут счёт «Оплачен» без загрузки выписки',
  },
  connection: {
    title: 'Подключение',
    lead: 'Токен T-API выпускает директор в Т-Бизнесе: Интеграции → T-API → «Выпуск токена». Банк покажет его один раз',
    steps: 'Что отметить при выпуске токена',
    scopeAccounts: 'Информация о счетах компании',
    scopeOperations: 'Информация об операциях компании',
    scopePayments: 'Совершение платежей с рублёвого расчётного счёта',
    scopePaymentStatus: 'Оплата подписанных платёжных реестров сотрудников или самозанятых',
    scopeWebhooks: 'Управление вебхуками',
    scopeCompany: 'Информация о компании',
    scopesHint: {
      title: 'Зачем эти доступы',
      text: 'Счета и операции — для выписки и остатков, информация о компании — чтобы проверить ИНН, вебхуки — чтобы операции приходили за секунды. Платежи и статус платежа понадобятся для выплат по актам. «Ограничение счетов» — «Не ограничивать» или нужные счета. Выпускать токен лучше с учётной записи директора: токен умирает, если выпустивший сотрудник уходит',
      example: 'Забыли доступ «Управление вебхуками» — выписка всё равно придёт, но раз в 5 минут',
    },
    ipHint: {
      title: 'IP сервера в токене',
      text: 'Банк принимает запросы только с адресов, вписанных в токен (до 9 статических IP). Впишите адрес, с которого сервер платформы выходит в интернет. Другие адреса или доступы — только новым токеном',
      example: 'Сервер выходит в интернет с 203.0.113.10 — этот адрес и укажите при выпуске',
    },
    openCabinet: 'Выпустить токен в Т-Бизнесе',
    token: 'Токен T-API',
    tokenHint: 'Строка вида t.… — вставьте целиком',
    tokenSaved: 'Сохранён · {mask} · проверен {at}',
    tokenUnreadable: 'Сохранён · ключ шифрования недоступен',
    tokenReplace: 'Заменить токен',
    tokenCancel: 'Не менять',
    syncFrom: 'Загружать операции с',
    syncFromHint:
      'Не раньше 01.06.2023 — раньше у банка данных нет. Сменили дату — выписка перечитается, дубли не появятся',
    save: 'Проверить и сохранить',
    saved: 'Т-Банк подключён: {company}',
    syncFromSaved: 'Выписка перечитается с {date}',
    company: '{name} · ИНН {inn}',
    accounts: 'Счета в банке',
    accountsHint: {
      title: 'Какие счета загружаются',
      text: 'Загружаются рублёвые счета, которые есть в «Счетах студии» с тем же номером. «Подключить» заводит счёт студии с остатком банка на дату начала загрузки',
      example: 'Расчётный ****0417 из реквизитов уже есть — он загружается сам',
    },
    accountsEmpty: 'Банк не вернул счетов — проверьте у токена доступ «Информация о счетах компании»',
    link: 'Подключить',
    linked: 'Загружается',
    foreign: 'Валютный — не загружается',
    linkedToast: 'Счёт подключён — выписка загружается',
  },
  state: {
    title: 'Состояние',
    lead: 'Синхронизация раз в 5 минут и по вебхуку банка',
    ok: 'Работает · {ago}',
    never: 'Первая синхронизация — через несколько секунд',
    paused: 'На паузе — выписка не загружается',
    error: 'Не синхронизируется',
    refresh: 'Обновить сейчас',
    refreshed: 'Запросили выписку у банка — обновим через несколько секунд',
    pause: 'Пауза',
    resume: 'Продолжить',
    pausedToast: 'Синхронизация на паузе',
    resumedToast: 'Синхронизация продолжена',
    webhooksOn: 'Вебхуки подключены — операции приходят за секунды',
    webhooksNoUrl: 'Вебхуки не подключены: адрес платформы не на HTTPS. Выписка загружается раз в 5 минут',
    webhooksFailed: 'Банк не принял подписку на вебхуки: {message}. Выписка загружается раз в 5 минут',
    webhooksRetry: 'Подключить заново',
    webhooksHint: {
      title: 'Почему операции приходят с задержкой',
      text: 'Банк проводит операцию не сразу: от появления до финального статуса бывает 3–4 дня, поэтому платформа каждый раз перечитывает последние 3 дня. Вебхук только будит синхронизацию — сумма и счёт всегда берутся из выписки',
      example: 'Платёж клиента пришёл вечером — он появится, как только банк его проведёт',
    },
    lastError: 'Последняя ошибка: {message}',
    requestId: 'Код запроса для поддержки банка: {id}',
    forget: 'Забыть токен',
    forgetHint: 'Токен удалится из платформы, подписки на вебхуки — из банка. Выписка и оплаты останутся',
    forgotten: 'Токен Т-Банка удалён',
  },
  notConnected: {
    title: 'Т-Банк не подключён',
    text: 'Подключите токен T-API — выписка будет приходить сама',
  },
  overview: {
    byBank: 'По банку {amount} · {time}',
    mismatch: 'Расходится с расчётным на {amount}',
    hint: {
      title: 'Остаток по банку и расчётный',
      text: 'Расчётный — начальный остаток счёта плюс записанные оплаты, минус расходы и выплаты. По банку — остаток в Т-Банке на момент синхронизации. Расходятся — значит, не всё из выписки разобрано или начальный остаток неверный',
      example: 'В «Разобрать» лежит списание 1 200 ₽ — пока его не разобрали, расчётный больше банковского',
    },
  },
  payments: {
    refresh: 'Обновить из банка',
    refreshHint: 'Запросить новые операции у Т-Банка сейчас, не дожидаясь синхронизации раз в 5 минут',
  },
  cert: {
    title: 'Выплаты',
    lead: 'Прямые платежи по актам из Т-Банка: нужны сертификат mTLS (RSA) и счёт, с которого уходят деньги',
    hint: {
      title: 'Сертификат для платежей',
      text: 'Сертификат выпускает директор в Т-Бизнесе: Интеграции → T-API → «Выпуск сертификата» → mTLS → RSA, заявку подписывает КЭП. Ключ private.key можно скачать только один раз — на третьем шаге. Сертификат живёт год и привязан к токену: выпустили новый токен — нужен и новый сертификат',
      example: 'Скачайте open-api-cert.pem и private.key и загрузите оба файла сюда',
    },
    certFile: 'Сертификат open-api-cert.pem',
    keyFile: 'Ключ private.key',
    save: 'Проверить и сохранить',
    saved: 'Сертификат сохранён — действует до {date}',
    valid: 'Сертификат · {subject} · действует до {date}',
    expiring: 'Истекает {date} — выпустите новый в Т-Бизнесе',
    replace: 'Заменить сертификат',
    cancel: 'Не менять',
    none: 'Сертификата нет — выплаты недоступны',
    filesRequired: 'Загрузите оба файла: сертификат и ключ',
    account: 'Счёт для выплат',
    accountHint: 'Рублёвый счёт студии в Т-Банке — с него уходят платежи реестров',
    accountEmpty: 'Подключите счёт Т-Банка в карточке «Подключение»',
    accountSaved: 'Счёт для выплат сохранён',
    problems: {
      cert_unreadable: 'файл сертификата не читается — нужен open-api-cert.pem в формате PEM',
      key_unreadable: 'файл ключа не читается — нужен private.key в формате PEM',
      pair_mismatch: 'ключ от другого сертификата',
      expired: 'срок сертификата истёк',
    },
  },
  today: {
    error: 'Т-Банк не синхронизируется',
    failed: {
      one: 'Реестр: {count} платёж с ошибкой',
      few: 'Реестр: {count} платежа с ошибкой',
      many: 'Реестр: {count} платежей с ошибкой',
      other: 'Реестр: {count} платежа с ошибкой',
    },
  },
} as const;

/** Реестр выплат на вкладке «Выплаты» (ключи `finance.registry.*`). */
export const ruFinanceRegistry = {
  title: 'Реестр № {number}',
  collect: 'Собрать реестр',
  collectHint: 'Подписанные акты, по которым ещё не выплачено, — платежами из Т-Банка',
  hint: {
    title: 'Реестр и прямой платёж',
    text: 'Реестр собирается из подписанных актов о выплате: сумма — остаток по акту, получатель — из «Данных и договора» сотрудника. После «Отправить в банк» каждый платёж уходит из Т-Банка сразу — деньги не вернуть. Исполненный платёж сам отмечает выплату по акту, сотрудник получает уведомление',
    example: 'Акт АВ-2026-0007 на 40 000 ₽ подписан — «Собрать реестр» добавит платёж Анне на 40 000 ₽',
  },
  readiness: {
    not_connected: 'Подключите Т-Банк: Настройки → Финансы → Т-Банк',
    no_cert: 'Для выплат нужен сертификат Т-Банка: Настройки → Т-Банк → «Выплаты»',
    no_account: 'Выберите счёт для выплат: Настройки → Т-Банк → «Выплаты»',
  },
  openSettings: 'Открыть настройки',
  states: {
    draft: 'Черновик',
    sending: 'Отправляется',
    sent: 'В банке',
    done: 'Завершён',
  },
  lineStates: {
    draft: 'К отправке',
    sending: 'Отправляется',
    in_progress: 'В банке',
    unknown: 'Ждём ответа банка',
    executed: 'Исполнен',
    failed: 'Не прошёл',
    cancelled: 'Отменён',
  },
  failedReason: 'Не прошёл: {reason}',
  remove: 'Убрать',
  removed: 'Акт убран из реестра',
  problemsTitle: 'Не попадут в реестр',
  problemsHint: 'Заполните данные сотрудника и нажмите «Собрать реестр» ещё раз — акт добавится в черновик',
  problems: {
    no_form: 'нет формы работы',
    no_account: 'нет БИК или счёта',
    account_mismatch: 'счёт не сходится с БИК',
    no_inn: 'нет ИНН — у самозанятого и ИП он обязателен',
  },
  fillData: 'Заполнить данные',
  total: 'Итого {amount}',
  available: 'На счёте {amount}',
  availableUnknown: 'Остаток по банку ещё не загружен',
  overAvailable: 'Больше, чем доступно на счёте, — часть платежей может не пройти',
  send: 'Отправить в банк · {payments} на {amount}',
  payments: {
    one: '{count} платёж',
    few: '{count} платежа',
    many: '{count} платежей',
    other: '{count} платежа',
  },
  confirm: {
    title: 'Отправить платежи в банк?',
    text: 'Деньги уйдут из Т-Банка сразу — вернуть их платформа не сможет',
    account: 'Счёт списания',
    count: 'Платежей',
    total: 'Итого',
    send: 'Отправить',
    cancel: 'Не отправлять',
  },
  sent: 'Реестр № {number} отправлен — статусы платежей обновятся сами',
  removeDraft: 'Удалить черновик',
  draftRemoved: 'Черновик реестра удалён',
  history: 'Прошлые реестры',
  emptyTitle: 'Реестров пока нет',
  emptyText: 'Соберите реестр, когда акты о выплате подписаны',
  pending: {
    one: 'Ещё {count} акт к выплате',
    few: 'Ещё {count} акта к выплате',
    many: 'Ещё {count} актов к выплате',
    other: 'Ещё {count} акта к выплате',
  },
  addMore: 'Добавить в реестр',
  counts: 'исполнено {executed} из {total}',
  sentAt: 'отправил {name} · {date}',
  purpose: 'Оплата по акту {number} от {date}. НДС не облагается',
  failedUnknown: 'банк не объяснил причину',
  notConfirmed: 'Банк не подтвердил платёж — проверьте в Т-Бизнесе',
  cancelled: 'платёж отменён',
} as const;

/** Ошибки банка (в `errors.finance`). */
export const ruFinanceBankErrors = {
  bank_not_connected: 'Т-Банк не подключён: Настройки → Финансы → Т-Банк',
  bank_unauthorized: 'Токен Т-Банка больше не действует — выпустите новый в Т-Бизнесе',
  bank_ip_forbidden: 'Банк не принимает запросы с адреса сервера — выпустите токен с IP сервера',
  bank_scope_missing: 'У токена нет доступа «{scope}» — выпустите токен с этим доступом',
  bank_foreign_company: 'Токен выпущен для ИНН {inn}, а в реквизитах студии другой',
  bank_cert_required: 'Для выплат нужен сертификат Т-Банка',
  bank_cert_invalid: 'Сертификат не подходит: {problem}',
  bank_unavailable: 'Т-Банк не отвечает — попробуем ещё раз через несколько минут',
  bank_rejected: 'Банк отклонил запрос: {message}',
  bank_bad_response: 'Т-Банк ответил не так, как ожидалось. Код запроса для поддержки: {requestId}',
  bank_sync_failed:
    'Не удалось разобрать выписку банка — повторим через 5 минут. Если ошибка не уйдёт, напишите разработчикам',
  bank_too_many_operations:
    'Операций за период слишком много — выписка загружена не вся. Сдвиньте «Загружать операции с» ближе к сегодняшнему дню',
  bank_sync_from: 'Дата начала загрузки — не раньше {from} и не позже сегодняшнего дня',
  bank_paused: 'Синхронизация с Т-Банком на паузе — продолжите её в Настройках → Т-Банк',
  bank_payout_account_required: 'Выберите счёт для выплат: Настройки → Т-Банк → «Выплаты»',
  payout_registry_empty: 'Нет подписанных актов к выплате',
  payout_registry_sent: 'Реестр уже отправлен — изменить его нельзя',
} as const;

/** «История» и журнал (в `audit`). */
export const ruFinanceBankAudit = {
  actions: {
    finance_bank: {
      connected: 'Подключён Т-Банк',
      token_changed: 'Заменён токен Т-Банка',
      changed: 'Изменены настройки Т-Банка',
      paused: 'Синхронизация с Т-Банком на паузе',
      resumed: 'Синхронизация с Т-Банком продолжена',
      forgotten: 'Токен Т-Банка удалён',
      certificate_saved: 'Загружен сертификат Т-Банка',
    },
    finance_payout_registry: {
      collected: 'Собран реестр выплат',
      line_removed: 'Акт убран из реестра',
      removed: 'Черновик реестра удалён',
      sent: 'Реестр отправлен в банк',
    },
  },
  entities: {
    finance_bank: 'Подключение Т-Банка',
    finance_payout_registry: 'Реестр выплат',
  },
  fields: {
    company: 'Компания',
    syncFrom: 'Загружать операции с',
    bankState: 'Состояние синхронизации',
    certSubject: 'Сертификат выдан',
    certExpiresOn: 'Сертификат действует до',
    registryNumber: 'Номер реестра',
    lines: 'Платежей',
  },
} as const;

/** Типы уведомлений (в `notifications`). */
export const ruFinanceBankNotificationTypes = {
  typeFinanceBankError: 'Т-Банк не синхронизируется',
  typeFinanceBankErrorHint:
    'Администраторам: токен перестал действовать, банк не принимает адрес сервера или не отвечает — раз в день',
  typeFinanceBankPending: 'Строки выписки для разбора',
  typeFinanceBankPendingHint: 'Администраторам: из Т-Банка пришли строки, которые платформа не разнесла сама',
  typeFinanceBankCert: 'Сертификат Т-Банка истекает',
  typeFinanceBankCertHint:
    'Администраторам: за 14 и 3 дня до конца срока сертификата для выплат и в день истечения',
  typeFinancePayoutRegistry: 'Реестр выплат исполнен',
  typeFinancePayoutRegistryHint: 'Тому, кто отправил реестр: все платежи дошли до конечного статуса',
  typeFinancePayoutFailed: 'Платёж реестра не прошёл',
  typeFinancePayoutFailedHint:
    'Тому, кто отправил реестр: банк отклонил или отменил платёж — причина в уведомлении',
} as const;

/** Тексты уведомлений (в `finance.notifications`). */
export const ruFinanceBankNotifications = {
  bankErrorTitle: 'Т-Банк: {problem}',
  bankErrorBody: 'Что сделать — в Настройках → Т-Банк',
  bankPendingTitle: lines('В выписке', 'для разбора'),
  bankPendingBody: 'Финансы → Оплаты → «Разобрать»',
  bankCertTitle: 'Сертификат Т-Банка истекает {date}',
  bankCertExpiredTitle: 'Сертификат Т-Банка истёк {date}',
  bankCertBody:
    'Выплаты перестанут уходить — выпустите новый сертификат и загрузите его в Настройках → Т-Банк',
  registryDoneTitle: 'Реестр № {number}: исполнено {executed} из {total}',
  registryDoneBody: 'Статусы платежей — на вкладке «Выплаты»',
  payoutFailedTitle: 'Платёж {name} не прошёл: {reason}',
  payoutFailedBody: 'На {amount} — акт снова можно включить в реестр',
} as const;
